const usDollarFormatter = new Intl.NumberFormat("en-US", {
  currency: "USD",
  maximumFractionDigits: 0,
  style: "currency",
});

export const formatDollars = (cents: number) =>
  usDollarFormatter.format(cents / 100);

export const isStripeGoalMet = (fundedCents: number, goalAmountCents: number) =>
  goalAmountCents > 0 && fundedCents >= goalAmountCents;

export const QUICK_OPTION_DOLLARS = [50, 100, 200, 500, 1000];
